import { render, staticRenderFns } from "./PageCanvas.vue?vue&type=template&id=e6f165fc&scoped=true"
import script from "./PageCanvas.vue?vue&type=script&lang=js"
export * from "./PageCanvas.vue?vue&type=script&lang=js"
import style0 from "./PageCanvas.vue?vue&type=style&index=0&id=e6f165fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f165fc",
  null
  
)

export default component.exports